import { getFirebaseAnalytics, getFirebaseAuth, initializeFirebase } from '@repo/services/firebase';
import { logEvent as firebaseLogEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_API_KEY,
  authDomain: import.meta.env.VITE_APP_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_APP_PROJECT_ID,
  storageBucket: import.meta.env.VITE_APP_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_APP_MESSAGING_ID,
  appId: import.meta.env.VITE_APP_APP_ID,
  measurementId: import.meta.env.VITE_APP_MEASUREMENT_ID,
  databaseURL: import.meta.env.VITE_APP_DATABASE_URL,
};

export const app = initializeFirebase(firebaseConfig);
export const auth = getFirebaseAuth(app);
export const analytics = getFirebaseAnalytics(app);

const logEvent = (eventName, eventParams) => {
  if (import.meta.env.VITE_APP_ENV !== 'production') return;
  firebaseLogEvent(analytics, eventName, eventParams);
};

export const firebaseEvent = {
  signUp: ({ userId, firebaseUserId, providerCode }) => {
    logEvent('sign_up', {
      user_id: userId,
      firebase_user_id: firebaseUserId,
      provider_code: providerCode,
      environment: import.meta.env.VITE_APP_ENV,
    });
  },
};
